import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

const buildVisiblePages = (totalPages, currentPage) => {
  if (totalPages <= 5) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }

  if (currentPage <= 3) {
    return [1, 2, 3, 'ellipsis', totalPages];
  }

  if (currentPage >= totalPages - 2) {
    return [1, 'ellipsis', totalPages - 2, totalPages - 1, totalPages];
  }

  return [1, 'ellipsis', currentPage, 'ellipsis-right', totalPages];
};

const TablePaginationFooter = ({ totalItems, currentPage, pageSize, onPageChange, className }) => {
  if (!totalItems || totalItems <= pageSize) {
    return null;
  }

  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const safeCurrentPage = Math.min(Math.max(currentPage, 1), totalPages);
  const visiblePages = buildVisiblePages(totalPages, safeCurrentPage);

  return (
    <div className={`med-table-pagination ${className}`.trim()}>
      <div className="med-table-pagination-pages">
        <Button
          color="white"
          className="med-table-pagination-btn is-nav"
          size="sm"
          disabled={safeCurrentPage === 1}
          onClick={() => onPageChange(Math.max(1, safeCurrentPage - 1))}
          aria-label="Oldingi sahifa"
        >
          <span className="med-table-pagination-icon" aria-hidden="true">
            {'<'}
          </span>
        </Button>
        {visiblePages.map(pageNo =>
          typeof pageNo === 'string' ? (
            <span key={pageNo} className="med-table-pagination-ellipsis">
              ...
            </span>
          ) : (
            <Button
              key={pageNo}
              color={safeCurrentPage === pageNo ? 'primary' : 'white'}
              className={`med-table-pagination-btn font-weight-bold ${safeCurrentPage === pageNo ? 'is-active' : ''} ${
                safeCurrentPage === pageNo ? 'text-white' : 'text-500'
              }`}
              size="sm"
              onClick={() => onPageChange(pageNo)}
              aria-label={`${pageNo}-sahifa`}
            >
              {pageNo}
            </Button>
          )
        )}
        <Button
          color="white"
          className="med-table-pagination-btn is-nav"
          size="sm"
          disabled={safeCurrentPage === totalPages}
          onClick={() => onPageChange(Math.min(totalPages, safeCurrentPage + 1))}
          aria-label="Keyingi sahifa"
        >
          <span className="med-table-pagination-icon" aria-hidden="true">
            {'>'}
          </span>
        </Button>
      </div>
    </div>
  );
};

TablePaginationFooter.propTypes = {
  totalItems: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  className: PropTypes.string
};

TablePaginationFooter.defaultProps = {
  className: ''
};

export default TablePaginationFooter;
